function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { onSSR } from '../../plugins/Platform.js';
import Intersection from '../../directives/Intersection.js';
import TagMixin from '../../mixins/tag.js';
import ListenersMixin from '../../mixins/listeners.js';
import { slot } from '../../utils/slot.js';
export default Vue.extend({
  name: 'QIntersection',
  mixins: [TagMixin, ListenersMixin],
  directives: {
    Intersection: Intersection
  },
  props: {
    once: Boolean,
    transition: String,
    ssrPrerender: Boolean,
    margin: String,
    threshold: [Number, Array],
    root: {
      "default": null
    },
    disable: Boolean
  },
  data: function data() {
    return {
      showing: onSSR === true ? this.ssrPrerender : false
    };
  },
  computed: {
    value: function value() {
      return this.root !== void 0 || this.margin !== void 0 || this.threshold !== void 0 ? {
        handler: this.__trigger,
        cfg: {
          root: this.root,
          rootMargin: this.margin,
          threshold: this.threshold
        }
      } : this.__trigger;
    },
    directives: function directives() {
      if (this.disable !== true && (onSSR !== true || this.once !== true || this.ssrPrerender !== true)) {
        return [{
          name: 'intersection',
          value: this.value,
          modifiers: {
            once: this.once
          }
        }];
      }
    }
  },
  methods: {
    __trigger: function __trigger(entry) {
      if (this.showing !== entry.isIntersecting) {
        this.showing = entry.isIntersecting;

        if (this.qListeners.visibility !== void 0) {
          this.$emit('visibility', this.showing);
        }
      }
    }
  },
  render: function render(h) {
    var content = this.showing === true ? [h('div', {
      key: 'content'
    }, slot(this, 'default'))] : void 0;
    return h(this.tag, {
      staticClass: 'q-intersection',
      on: _objectSpread({}, this.qListeners),
      directives: this.directives
    }, this.transition ? [h('transition', {
      props: {
        name: 'q-transition--' + this.transition
      }
    }, content)] : content);
  }
});